import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  changePasswordContainer: {
    display: 'flex',
    justifyContent: 'center',
    padding: `${theme.spacing(5.5)}px ${theme.spacing(2)}px`,
    background: theme.palette.white,
  },
  changePasswordForm: {
    width: '100%',
    [theme.breakpoints.up(580)]: {
      maxWidth: theme.spacing(62.5),
    },
  },
  passwordInputSection: {
    marginBottom: theme.spacing(3),
  },
  actionsContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  saveChangesButton: {
    marginLeft: theme.spacing(3),
  },
  link: {
    textDecoration: 'none',
  },
}))

export default useStyles
